/** Normaliza lista de CNAEs a partir de JSON ou array. */
export function parseCnaesList(jsonOrArray) {
  try {
    const raw = typeof jsonOrArray === 'string'
      ? JSON.parse(jsonOrArray || '[]')
      : (jsonOrArray || []);
    const arr = Array.isArray(raw) ? raw : [];
    return [...new Set(arr.map((x) => String(x || '').replace(/\D/g, '')).filter((c) => c.length >= 4))];
  } catch {
    return [];
  }
}

export function cnaesToJson(list) {
  const cleaned = parseCnaesList(list);
  return JSON.stringify(cleaned);
}
